import { memo } from 'react';

import { withMediaQueries } from '@cx-modules/react-utils';

import { OutrightMarkets } from './OutrightMarkets';

export * from './OutrightMarkets';

export default memo(withMediaQueries(OutrightMarkets));
